
// SVG Icon: close-circle
export default { id: "terriajs-close-circle" };
export const id = "terriajs-close-circle";
export const name = "close-circle";
